import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import type { Vacancy, EditVacancyRequest } from '../types';
import { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';
import { MutationKey } from '@shared/config';

export const useEditVacancy = (
  id: string
): UseMutationResult<
  Vacancy,
  AxiosError<TFormErrorResponse>,
  EditVacancyRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.EDIT_VACANCY],
    mutationFn: (params: EditVacancyRequest) =>
      vacancyApi.editVacancy(params, id),
  });
};
